import * as React from "react";
const SvgFiBrandsTMobile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#151A2D" d="M2.187 15.92h4.854v-4.854H2.187z" />
    <path
      fill="#151A2D"
      d="M13.871 1.145c3.955.07 6.313 2.706 6.66 7.526l1.284-.208L21.57 0H2.426l-.24 8.463 1.281.208c.348-4.82 2.671-7.457 6.66-7.526v17.723c0 3.225-.556 3.746-4.023 3.781V24h11.791v-1.352c-3.468-.034-4.024-.556-4.024-3.781z"
    />
    <path fill="#151A2D" d="M16.918 15.92h4.854v-4.854h-4.854z" />
  </svg>
);
export default SvgFiBrandsTMobile;
